import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import pageTitleFromPathname from '../../helpers/pageTitleFromPathname';
import useActiveInfo from '../../Hooks/useActiveInfo';

const useStyles = makeStyles((theme: any) => ({
    root: (props: any) => ({
        color: '#666',
        marginBottom: theme.spacing(4),
        marginTop: theme.spacing(4),
        padding: `${theme.spacing(3)}`,
        paddingLeft: 0,
        textAlign: 'left',
    }),
}));

const PageHeading = ({ heading }: any) => {
    const nameMap = pageTitleFromPathname(useActiveInfo());
    // @ts-ignore
    const classes = useStyles();
    let name = nameMap[window.location.pathname];
    return (
        <Container classes={{ root: classes.root }}>
            <Typography component="h1" variant="h4">
                {name}
            </Typography>
        </Container>
    );
};

export default PageHeading;
